import React from 'react';
import { motion } from 'framer-motion';
import { skills } from '../../data/constants';
import styles from './Skills.module.css';

const fadeUpVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } }
};

const badgeVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } }
};

const Skills = () => {
  return (
    <section id="skills" className={styles.skillsSection}>
      <div className={styles.container}>
        <motion.div 
          className={styles.header}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUpVariants}
        >
          <span className={styles.label}>EXPERTISE</span>
          <h2 className={styles.h2}>Technologies & Tools</h2>
          <p className={styles.subtitle}>
            Tools and platforms I work with daily to build production AI systems.
          </p>
        </motion.div>

        <div className={styles.skillsGrid}>
          {skills.map((category, idx) => {
            const duplicatedSkills = [...category.skills, ...category.skills, ...category.skills, ...category.skills];
            
            return (
              <motion.div 
                key={category.title} 
                className={styles.categoryBlock}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={fadeUpVariants}
              >
                <h3 className={styles.categoryTitle}>
                  {category.title}
                </h3>
                
                <div className={styles.marqueeContainer}>
                  <div 
                    className={styles.marqueeTrack}
                    style={{ 
                      animationDuration: `${Math.max(category.skills.length * 4.5, 40)}s`,
                      animationDirection: idx % 2 === 1 ? 'reverse' : 'normal'
                    }}
                  >
                    {duplicatedSkills.map((skill, i) => (
                      <div key={`${skill.name}-${i}`} className={styles.badge}>
                        {skill.image && <img src={skill.image} alt={skill.name} className={styles.skillIcon} />}
                        {skill.name}
                      </div>
                    ))}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
